"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = toCamelCase;

function toCamelCase(str) {
  return str.toLowerCase().replace(/\s\w\S*/g, function (txt) {
    return txt.charAt(1).toUpperCase() + txt.substr(2);
  }).replace(/\s+/g, '');
}